import { render, staticRenderFns } from "./PhoneNormalizedInput.vue?vue&type=template&id=806f2c68&scoped=true&"
import script from "./PhoneNormalizedInput.vue?vue&type=script&lang=ts&"
export * from "./PhoneNormalizedInput.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneNormalizedInput.vue?vue&type=style&index=0&id=806f2c68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806f2c68",
  null
  
)

export default component.exports